import React, { useState } from 'react';
import {
  Dropdown,
  DropdownMenu,
  DropdownToggle,
  Form
} from 'reactstrap';

import FullScreenDropdown from '../Components/Common/FullScreenDropdown';
import NotificationDropdown from '../Components/Common/NotificationDropdown';
import ProfileDropdown from '../Components/Common/ProfileDropdown';
import LightDark from '../Components/Common/LightDark';
import logoLight from "../assets/images/logo-dark.png";
import { changeSidebarVisibility } from '../slices/layouts/thunk';
import { useSelector, useDispatch } from "react-redux";
import { createSelector } from 'reselect';

const Header = ({ onChangeLayoutMode, layoutModeType, headerClass }) => {
  const dispatch = useDispatch();

  const selectDashboardData = createSelector(
    (state) => state.Layout,
    (layout) => layout.sidebarVisibilitytype
  );

  const sidebarVisibilitytype = useSelector(selectDashboardData);

  const [search, setSearch] = useState(false);

  const toogleSearch = () => {
    setSearch(!search);
  };

  // ✅ MAIN FIX: Mobile + Desktop Sidebar Toggle
  const toogleMenuBtn = () => {
    const width = window.innerWidth;

    // Redux state (kept for compatibility)
    dispatch(changeSidebarVisibility("show"));

    if (width <= 767) {
      // Mobile behavior
      document.body.classList.toggle("vertical-sidebar-enable");
    } else {
      // Desktop behavior
      document.body.classList.toggle("vertical-sidebar-enable");
      document.querySelector(".hamburger-icon")?.classList.toggle("open");
    }
  };

  return (
    <React.Fragment>
      <header id="page-topbar" className={headerClass}>
        <div className="layout-width">
          <div className="navbar-header">

            {/* LEFT SECTION */}
            <div className="d-flex align-items-center">

              {/* ✅ HAMBURGER BUTTON (VISIBLE ON MOBILE) */}
             <img src={logoLight} alt="" height="35" />

            </div>

            {/* RIGHT SECTION */}
            <div className="d-flex align-items-center">

              {/* Mobile Search */}
              <Dropdown
                isOpen={search}
                toggle={toogleSearch}
                className="d-md-none topbar-head-dropdown header-item"
              >
                <DropdownToggle
                  type="button"
                  tag="button"
                  className="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle"
                >
                  <i className="bx bx-search fs-22"></i>
                </DropdownToggle>
                <DropdownMenu className="dropdown-menu-lg dropdown-menu-end p-0">
                  <Form className="p-3">
                    <div className="form-group m-0">
                      <div className="input-group">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Search ..."
                        />
                        <button className="btn btn-primary" type="submit">
                          <i className="mdi mdi-magnify"></i>
                        </button>
                      </div>
                    </div>
                  </Form>
                </DropdownMenu>
              </Dropdown>
              <FullScreenDropdown />
              <NotificationDropdown />
              <ProfileDropdown />
            </div>

          </div>
        </div>
      </header>
    </React.Fragment>
  );
};

export default Header;
